export function CrewPickerSearchInput({
  value,
  onChange,
  allRegions,
}: {
  value: string;
  onChange: (v: string) => void;
  allRegions: boolean;
}) {
  return (
    <input
      autoFocus
      value={value}
      placeholder={allRegions ? 'Search all staff…' : 'Search staff in region…'}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Search staff"
      style={{
        height: 32,
        padding: '0 10px',
        fontSize: 13,
        border: '1px solid var(--nb-border-2)',
        borderRadius: 8,
        background: 'var(--nb-bg)',
        color: 'var(--nb-ink)',
        marginBottom: 10,
      }}
    />
  );
}
